export default {
  'component.documents.title': 'Dokument',
  'component.documents.description':
    'Her finner du alle relevante dokumentkoder når de blir tilgjengelige.',
};
